import { Href, RelativePathString, router, useSegments } from "expo-router";
import { ActionButton, actionButtonStyles } from "./ActionButton";

interface ExpandCollapseButtonProps {
  /** Entity type for building the expand URL */
  entityType?: string;
  /** Entity ID for preview mode expand URL */
  entityId?: string;
  /** Whether this is create mode (uses /new route) vs preview mode (uses /[id] route) */
  isCreateMode?: boolean;
}

export function ExpandCollapseButton({ entityType, entityId, isCreateMode }: ExpandCollapseButtonProps) {
  const segs = useSegments();

  if (isCreateMode) {
    // Create mode: check for "new" in segments
    const isExpanded = (segs as string[]).includes("new");

    if (isExpanded) {
      // Collapse: navigate to table page with new=true panel param
      const handleCollapse = () => {
        if (!entityType) return;
        router.replace({
          pathname: `/${entityType}s` as RelativePathString,
          params: { panel: entityType, new: "true" },
        } as Href);
      };

      return (
        <ActionButton
          icon="arrow-collapse"
          onPress={handleCollapse}
          tooltip="Collapse"
          style={actionButtonStyles.iconBtn}
          tooltipOffsetX={-20}
        />
      );
    }

    // Only show expand if we have entityType
    if (!entityType) return null;

    return (
      <ActionButton
        icon="fit-to-screen"
        onPress={() => router.push(`/${entityType}s/new` as RelativePathString)}
        tooltip="Expand"
        style={actionButtonStyles.iconBtn}
        tooltipOffsetX={-13}
      />
    );
  }

  // Preview mode: check for "[id]" in segments
  const isExpanded = (segs as string[]).includes("[id]");

  if (isExpanded) {
    // Collapse: navigate to table page with panel params instead of using back()
    const handleCollapse = () => {
      if (!entityType || !entityId) return;
      router.replace({
        pathname: `/${entityType}s` as RelativePathString,
        params: { panel: entityType, id: entityId, tab: "overview" },
      } as Href);
    };

    return (
      <ActionButton
        icon="arrow-collapse"
        onPress={handleCollapse}
        tooltip="Collapse"
        style={actionButtonStyles.iconBtn}
        tooltipOffsetX={-20}
      />
    );
  }

  // Only show expand if we have entityType
  if (!entityType) return null;

  return (
    <ActionButton
      icon="fit-to-screen"
      onPress={() => router.push(`/${entityType}s/${entityType}/${entityId}` as RelativePathString)}
      tooltip="Expand"
      style={actionButtonStyles.iconBtn}
      tooltipOffsetX={-13}
    />
  );
}
